import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import {
  AppToast,
  ToastAction,
  ToastService,
} from '../../../core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  protected readonly toastService = inject(ToastService);

  protected remove(toast: AppToast): void {
    this.toastService.remove(toast.id);
  }

  protected runAction(toast: AppToast, action: ToastAction): void {
    if (action.closeOnClick !== false) {
      this.toastService.remove(toast.id);
    }

    action.callback();
  }
}